import React from 'react'
import {LinkButton} from '@components/common/base/buttons'
import {Icon} from '@components/common/base/icon'
import {boardSettingsStore as store, TabId} from './board-settings-store'

interface BoardSettingsIconT {
  currentTabId?: TabId
  onClick?: () => void
}

const BoardSettingsIcon = ({
  currentTabId = 'boardSettings',
  onClick
}: BoardSettingsIconT) => {
  const onOpenSettings = () => {
    if (onClick) {
      onClick()
    } else {
      store.setCurrentTabId(currentTabId)
      store.toggle()
    }
  }

  return (
    <LinkButton onClick={onOpenSettings} size="small" noPaddings>
      <Icon icon="IconSettings" color="icon-secondary" />
    </LinkButton>
  )
}

export default BoardSettingsIcon
